import { FormStore } from '@roc/feature-app-core';
import { action, makeObservable, observable } from 'mobx';

const idAndFinancialInformationOptionsForm = {
  fields: {
    sendIdLink: {
      value: false,
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};
export class IdAndFinancialInformationOptionsFormStore extends FormStore {

  oldFormValues: any;

  constructor(globalStore) {
    super({ ...idAndFinancialInformationOptionsForm }, globalStore);

    makeObservable(this, {
      oldFormValues: observable,
      setOldFormValues: action
    });
    this.setDefaults();
  }

  reset() {
    super.reset();
    this.setDefaults();
  }

  setDefaults() {
    this.setOldFormValues(null);
  }

  setOldFormValues(oldFormValues) {
    this.oldFormValues = oldFormValues;
  }

}